import { render, staticRenderFns } from "./RequirementFilesList.vue?vue&type=template&id=21fe5199&scoped=true"
import script from "./RequirementFilesList.vue?vue&type=script&lang=js"
export * from "./RequirementFilesList.vue?vue&type=script&lang=js"
import style0 from "./RequirementFilesList.vue?vue&type=style&index=0&id=21fe5199&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fe5199",
  null
  
)

export default component.exports